"use strict";

function formatDate(date) {
  return date.toJSON();
}

module.exports = formatDate;